// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1gUKO","right":"Footer_right__1d3xS","buttons":"Footer_buttons__laqns"};